import Provider from './src/providers/provider';

import './src/theme/theme.scss';

export const wrapPageElement = Provider;
